require("../jquery.actual/jquery.actual.min.js");
require("./select2.css");
require("./select2-bootstrap.css");
require("./select2.js");


/*****************
 ** WEBPACK FOOTER
 ** ./Content/Plugins/select2/select2-includer.js
 ** module id = 43
 ** module chunks = 15
 **/